import {
  BaseApiService,
  type JsonApiResponse,
  type ServiceOptions,
} from './base.service';

export interface OutputStyle {
  id: string;
  type: string;
  attributes: {
    name: string;
    description?: string;
    system_prompt: string;
    model_config?: Record<string, unknown>;
    is_default?: boolean;
    is_active?: boolean;
    preview_image_url?: string;
    created_at: string;
    updated_at: string;
  };
}

export class OutputStylesService extends BaseApiService {
  async getOutputStyles(options?: ServiceOptions): Promise<OutputStyle[]> {
    const response = await this.httpGet<JsonApiResponse<OutputStyle[]>>(
      '/v1/output-styles',
      undefined,
      {
        loading: { trackEndpoint: 'output-styles-list' },
        ...options,
      }
    );
    return response.data;
  }

  async getOutputStyle(
    styleId: string,
    options?: ServiceOptions
  ): Promise<OutputStyle> {
    const response = await this.httpGet<JsonApiResponse<OutputStyle>>(
      `/v1/output-styles/${styleId}`,
      undefined,
      {
        loading: { trackEndpoint: `output-styles-get-${styleId}` },
        ...options,
      }
    );
    return response.data;
  }

  async getDefaultOutputStyle(options?: ServiceOptions): Promise<OutputStyle> {
    const response = await this.httpGet<JsonApiResponse<OutputStyle>>(
      '/v1/output-styles/default',
      undefined,
      {
        loading: { trackEndpoint: 'output-styles-default' },
        ...options,
      }
    );
    return response.data;
  }
}

export const outputStylesService = new OutputStylesService();
